/**
 * The session — **`@fiveox/shell`'s store, not ours**.
 *
 * ADR-0004 records why this file is eight lines rather than two hundred. The
 * shell already implements every obligation SSO_INTEGRATION §3.3/§3.4 names,
 * and it implements them *once for the whole estate*:
 *
 * - one place that ends a session (`clearSession`, reached from `refreshSession`)
 * - observable (`useSession` over `useSyncExternalStore`, so clearing it
 *   actually re-renders)
 * - a serialized refresh shared by concurrent callers
 * - only an **answer** from auth ends a session; a 5xx does not
 * - `signOutEverywhere` awaits `POST /logout` with `keepalive` before clearing
 *
 * Writing our own would fork the thing ADR-0024/ADR-0037 exist to unify, and
 * would quietly re-acquire the five bugs the platform has already paid for.
 * If something is missing here, the fix goes in the shell, upstream.
 */

import { createSessionStore } from '@fiveox/shell'

import { AUTH_API } from './config'

/**
 * **Our own key** (SSO_INTEGRATION §3.2). Never read another app's storage:
 * different origins, and one app's session must never be revived from
 * another's.
 */
export const SESSION_KEY = 'fiveox.tdsreco_session'

export const session = createSessionStore({
  key: SESSION_KEY,
  authApiUrl: AUTH_API,
})

export type { Session } from '@fiveox/shell'
